module.exports = __webpack_public_path__ + "img/901172509.43eafa17.png";